import React, { Component } from 'react'
import { Button, FormControl, FormGroup, ControlLabel, Modal, Table } from 'react-bootstrap'

class sourceTextForm extends Component {
  updateSourceText = e => {
    e.preventDefault();
    return this.props.updateSourceText({ sourceText: e.target.value });
  };

  sendSourceText = e => {
    e.preventDefault();
    return this.props.sendSourceText({ sourceText: this.props.sourceText });
  };

  addUserWords = e => {
    e.preventDefault();
    return this.props.addUserWords({
      userWordsIds: this.props.wordsForAdd.filter(e => e.checked).map(e => e.wordId)
    });
  };

  render() {
    const words = this.props.wordsForAdd;

    return (
      <div>
        <Modal show={this.props.modalSourceTextState === 'close' ? false : true}>
            <Modal.Header closeButton onHide={this.props.toggleSourceTextModal}>
              <Modal.Title>Добавление английского текста</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {words.length === 0 ? (
                <FormGroup controlId="">
                  <ControlLabel>Источник слов</ControlLabel>
                  <FormControl
                    onChange={this.updateSourceText}
                    componentClass="textarea"
                    rows="8"
                    placeholder="Вставьте сюда английский текст... Максимальная длинна 3000 символов."
                  />
                  <span style={{ color: this.props.sourceText.length > 3000 ? 'red' : '' }}>
                    {this.props.sourceText.length}/3000
                  </span>
                </FormGroup>
              )
              : (
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th className="col-md-1"></th>
                      <th>Слово</th>
                      <th>Перевод</th>
                    </tr>
                  </thead>
                  <tbody>
                    {words.map(word => {
                      return (
                        <tr key={word.wordId}>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              onChange={() => this.props.checkUserWords({userWordId: word.wordId})}
                              defaultChecked={word.checked}
                              value={word.wordId}
                            />
                          </td>
                          <td>{word.wordValue}</td>
                          <td>{word.wordTranslate}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )
            }
            </Modal.Body>

            <Modal.Footer>
              <form onSubmit={words.length ? this.addUserWords : this.sendSourceText}>
                <Button disabled={this.props.isRequest ? true : false} onClick={this.props.toggleSourceTextModal}>Отмена</Button>
                <Button disabled={this.props.sourceText === '' || this.props.isRequest || this.props.sourceText.length > 3000 ? true : false} type="submit" bsStyle="primary">
                  {words.length ? 'Добавить слова' : 'Анализировать текст'}
                </Button>
              </form>
            </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default sourceTextForm;



// WEBPACK FOOTER //
// ./src/components/SourceTextForm.js